/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetKillerQuestionListQueryVariables = Types.Exact<{
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetKillerQuestionListQuery = { getKillerQuestionList: Array<{ id: number, name: string, choices: Array<{ id: number, name: string, icon_url: string }> }> };


export const GetKillerQuestionListDocument = gql`
    query GetKillerQuestionList($skip: Int, $limit: Int) {
  getKillerQuestionList(skip: $skip, limit: $limit) {
    id
    name
    choices {
      id
      name
      icon_url
    }
  }
}
    `;

/**
 * __useGetKillerQuestionListQuery__
 *
 * To run a query within a React component, call `useGetKillerQuestionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKillerQuestionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKillerQuestionListQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetKillerQuestionListQuery(baseOptions?: Apollo.QueryHookOptions<GetKillerQuestionListQuery, GetKillerQuestionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKillerQuestionListQuery, GetKillerQuestionListQueryVariables>(GetKillerQuestionListDocument, options);
      }
export function useGetKillerQuestionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKillerQuestionListQuery, GetKillerQuestionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKillerQuestionListQuery, GetKillerQuestionListQueryVariables>(GetKillerQuestionListDocument, options);
        }
export type GetKillerQuestionListQueryHookResult = ReturnType<typeof useGetKillerQuestionListQuery>;
export type GetKillerQuestionListLazyQueryHookResult = ReturnType<typeof useGetKillerQuestionListLazyQuery>;
export type GetKillerQuestionListQueryResult = Apollo.QueryResult<GetKillerQuestionListQuery, GetKillerQuestionListQueryVariables>;